export default "__VITE_ASSET__45f88451__"